import { InjectionToken } from '@angular/core';

export const TOAST_CONFIG_TOKEN = new InjectionToken('toast-config');
